/**
 * Default timeout for notifications to disappear
 */
export const NOTIFICATION_DEFAULT_EXPIRATION_TIME = 5000;
